/**
 * OnboardingPage saga functions
 */
import { call, put, takeLatest } from 'redux-saga/effects';
import { handleError } from '../../Lib/Utils/saga-utils';
import { actions } from './slice';
import InfluencerAPI from '../../Lib/Api/influencer.ts';

export function* getInfluencers({ payload: { params } }) {
  try {
    const response = yield call(InfluencerAPI.getAll, params);
    yield put(actions.getInfluencersSuccess(response));
  } catch (err) {
    yield handleError(actions.getInfluencersError, err);
  }
}

export function* getTeam() {
  try {
    const response = yield call(InfluencerAPI.getTeam);
    yield put(actions.getTeamSuccess(response));
  } catch (err) {
    yield handleError(actions.getTeamError, err);
  }
}

function* usersSaga() {
  yield takeLatest(actions.getInfluencers.type, getInfluencers);
  yield takeLatest(actions.getTeam.type, getTeam);
}

export default usersSaga;
